import { Action } from 'redux';
import ILoanEmail from '~Api/LoanEmail/ILoanEmail';
import LoanEmailsActionsEnum from './ActionsEnum';

export interface ILoanEmailsListAction extends Action {
    loanUuid: string;
    pageNumber: number;
    perPage: number;
}

export function loanEmailsListAction(
    loanUuid: string,
    pageNumber: number,
    perPage: number,
): ILoanEmailsListAction {
    return {
        loanUuid,
        pageNumber,
        perPage,
        type: LoanEmailsActionsEnum.LoanEmailsList,
    };
}

export interface ILoanEmailsSetAction extends Action {
    count: number;
    emails: ILoanEmail[];
    loanUuid: string;
}

export function loanEmailsSetAction(
    loanUuid: string,
    emails: ILoanEmail[],
    count: number,
): ILoanEmailsSetAction {
    return {
        count,
        emails,
        loanUuid,
        type: LoanEmailsActionsEnum.LoanEmailsSet,
    };
}

export interface ILoanEmailTextGetAction extends Action {
    loanEmailUuid: string;
}

export function loanEmailTextGetAction(
    loanEmailUuid: string,
): ILoanEmailTextGetAction {
    return {
        loanEmailUuid,
        type: LoanEmailsActionsEnum.LoanEmailTextGet,
    };
}

export interface ILoanEmailTextSetAction extends Action {
    loanEmailUuid: string;
    text: string;
}

export function loanEmailTextSetAction(
    loanEmailUuid: string,
    text: string,
): ILoanEmailTextSetAction {
    return {
        loanEmailUuid,
        text,
        type: LoanEmailsActionsEnum.LoanEmailTextSet,
    };
}
